module.exports = __webpack_public_path__ + "img/Icon-Pfeil-hoch-weis.cda8ebca.svg";